// extracted by mini-css-extract-plugin
export default {"msg_container":"cha","message":"eha","show":"fha","fromRD":"gha","fromCustomer":"hha","note":"iha","loading":"jha","image":"kha","initials":"lha","input_wrapper":"mha","input":"nha"};
    if(module.hot) {
      // 1726593108540
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  